export class DepositoViaBoletoRequestModel {
    constructor() { }

    contaGuid: string;
    valor: number;
    dataVencimento: Date;
    cedenteGuid: string;
    gestorGuid: string;
    saldoAlocadoId?: number;
}
export class DepositoViaPIXRequestModel {
    constructor() { }

    contaGuid: string;
    valor: number;
    dataVencimento: Date;
    cedenteGuid: string;
    gestorGuid: string;
    saldoAlocadoId?: number;
}



